import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../types'
import { GalleryItemData } from './gallery-item/gallery-item.component.converter'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../services/cms-converter/cms-converter.service'
import { MbColor } from '../../tailwind/enums/color-enum'
import { GalleryItemColor } from './gallery-item/gallery-item.component'

@Injectable({ providedIn: 'root' })
export class GalleryConverter extends CmsConverterService<GalleryData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      disableDetailsView: formData.st_disable_image_details_view?.value ?? false,
      backgroundColorAll: formData.st_background_color?.value?.identifier ?? MbColor.grey,
      enableBackgroundColor: formData.st_enable_background_color?.value ?? false,
      textColor: formData.st_text_color?.value?.identifier ?? MbColor.black,
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      columnsCount: +(formData.st_number_of_columns?.value?.identifier ?? 4),
      items: formData.st_items ?? defaultFSCatalog
    }
  }
}

export const GALLERY_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, GalleryData>>('GalleryConverter')

export interface GalleryData extends ConvertedComponentData {
  disableDetailsView: boolean;
  enableBackgroundColor: boolean;
  backgroundColorAll: GalleryItemColor;
  textColor: string;
  headline: TextInput;
  text: TextInput;
  columnsCount: number;
  items: FsCatalog<GalleryItemData>;
}
